import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import SurveyorModel from '../../Surveyor/models/SurveyorModel';

interface SurveyorSelectorState {
    searchResults: SurveyorModel[],
}

const initialState: SurveyorSelectorState = {
    searchResults: [],
}

export const SurveyorSelectorSlice = createSlice({
    name: "SurveyorSelector",
    initialState,
    reducers: {
        setSurveyorSelectorSearchResults: (state, action: PayloadAction<SurveyorModel[]>) => {
            state.searchResults = action.payload;
        },
    }
});

export const SurveyorSelectorSelector = createSelector(
    (state: RootState) => state.surveyorSelector,
    (data) => data
);

export const {
    setSurveyorSelectorSearchResults,
} = SurveyorSelectorSlice.actions;

export default SurveyorSelectorSlice.reducer;